if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
        this.elements.closeButton.focus();
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
if (!customElements.get('social-share')) {
  customElements.define('social-share', class ShareButton extends HTMLElement {
  constructor() {
    super();

    let currentProduct = location.href + '.json';
    let product =  this.getApiData(currentProduct);
    let self = this;
 
    this.elements = {
      facebookShare: this.querySelector('#fb_share'),
      twitterShare: this.querySelector('#twitter_share'),
      pinterestShare: this.querySelector('#pinterest_share'),
      product: ""
    }
    
    window.setTimeout(function(){
      self.updateElementsSrc();
    },1500)
    
 
    
  }
  updateElementsSrc() {
    
    if (this.elements.facebookShare) {
      let shareURL = 'http://www.facebook.com/share.php?u=' + encodeURIComponent(location.href);
      this.elements.facebookShare.setAttribute("href", shareURL);
    }
    if (this.elements.twitterShare) {
      
      let shareURL = 'http://www.twitter.com/share?text=' + this.elements.product.title + '&url=' + encodeURIComponent(location.href) + '&hashtags=storyonline';
      this.elements.twitterShare.setAttribute("href", shareURL);
    }
    if (this.elements.pinterestShare) {
      
      let shareURL = 'http://pinterest.com/pin/create/bookmarklet/?url=' + encodeURIComponent(location.href) + '&is_video=false&description=' + this.elements.product.title + '&media=' + this.elements.product.image.src;
      this.elements.pinterestShare.setAttribute("href", shareURL);
    }
  }
  getApiData(url) {
    let obj;
    let self = this;
    fetch(url)
    .then( response => response.json() )
    .then(data => self.setProductData(data));
    
  }
  setProductData(data) { 
    let productData = data.product;
    this.elements.product = productData;
    return productData;
  }

  });
}